import { ActionComponentWrapper } from "@flow/frontend/member/components/ActionComponentWrapper";
import { ActionComponentProps, pluginRegistry } from "@flow/frontend/member/plugin_api";
import { SocialShareActionConfig, social_share_action_type } from "../../common/action_types";
import { ShareComponentMain } from "./ShareComponentMain";
interface SocialShareUrls {
  whatsapp: string;
  facebook: string;
  twitter: string;
  copy: string;
}

export const handleSocialShareUrl = (props: ActionComponentProps<SocialShareActionConfig>): SocialShareUrls => {
  const whatsappUrl = handleWhatsAppShareUrl(props);
  const facebookUrl = handleFacebookShareUrl(props);
  const twitterUrl = handleTwitterShareUrl(props);
  const copy = handleCopy(props);

  return {
    whatsapp: whatsappUrl,
    facebook: facebookUrl,
    twitter: twitterUrl,
    copy: copy,
  };
};

export const handleWhatsAppShareUrl = (props: ActionComponentProps<SocialShareActionConfig>): string => {
  if (props.custom.shortenedUrl.whatsappOverride && props.custom.shortenedUrl.whatsappOverride.length > 0) {
    return props.custom.shortenedUrl.whatsappOverride;
  } else if (props.custom.shortenedUrl.whatsapp?.length > 0) {
    return props.custom.shortenedUrl.whatsapp;
  } else {
    return "";
  }
};

export const handleFacebookShareUrl = (props: ActionComponentProps<SocialShareActionConfig>): string => {
  if (props.custom.shortenedUrl.facebookOverride && props.custom.shortenedUrl.facebookOverride.length > 0) {
    return props.custom.shortenedUrl.facebookOverride;
  } else if (props.custom.shortenedUrl.facebook?.length > 0) {
    return props.custom.shortenedUrl.facebook;
  } else {
    return "";
  }
};

export const handleCopy = (props: ActionComponentProps<SocialShareActionConfig>): string => {
  if (props.custom.shortenedUrl.copy && props.custom.shortenedUrl.copy?.length > 0) {
    return props.custom.shortenedUrl.copy;
  } else {
    return "";
  }
};

export const handleTwitterShareUrl = (props: ActionComponentProps<SocialShareActionConfig>): string => {
  if (props.custom.shortenedUrl.twitterOverride && props.custom.shortenedUrl.twitterOverride.length > 0) {
    return props.custom.shortenedUrl.twitterOverride;
  } else if (props.custom.shortenedUrl.twitter?.length > 0) {
    return props.custom.shortenedUrl.twitter;
  } else {
    return "";
  }
};

pluginRegistry.registerActionComponent(
  social_share_action_type,

  (props) => {
    return (
      <>
        <ActionComponentWrapper>
          <ShareComponentMain {...props} />
        </ActionComponentWrapper>
      </>
    );
  }
);
